import * as angular from 'angular';
import CategoryNavigationBridge from './bridges/CategoryNavigationBridge';

angular
  .module('flowingly.runner.nav.categories')
  .component('categoryNavigation', CategoryNavigationBridge);
